<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex flex-wrap items-end">
                <div class="flex-grow">
                    <vs-button
                        v-if="isPermissionAdd()"
                        @click="addCamera"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-plus">
                        {{this.$t('notificationV.addNotification')}}
                    </vs-button>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="organizationBranchList"
                         :localeText=" {noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                         :animateRows="true"
                         :paginationPageSize="pageSize"
                         :pagination="true"
                         @pagination-changed="onPaginationChanged"
                         @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                v-model="currentPage"
                @input="loadPage"/>
        </div>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../ui-elements/Pagination.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererContent from "./cell-renderer/CellRendererContent";
import { isAPI, isRouter } from '../../../store/permission';
import { constAPI, constRouter } from '../../../store/constant';

export default {
    components: {
        AgGridVue,

        // Cell Renderer
        Pagination,
        CellRendererActions,
        CellRendererContent
    },
    data() {
        return {
            searchQuery: "",
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('notificationV.recipient'),
                    field: 'fullName',
                    width: 150
                },
                {
                    headerName: this.$t('notificationV.title'),
                    field: 'title',
                    width: 170
                },
                {
                    headerName: this.$t('notificationV.content'),
                    field: 'content',
                    cellRenderer: 'CellRendererContent',
                    width: 250
                },
                {
                    headerName: this.$t('notificationV.actions'),
                    field: 'actions',
                    width: 80,
                    cellRenderer: 'CellRendererActions',
                },
            ],
            organizationBranchList: [],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            pageSize: 50,
        }
    },
    created() {
        this.initScreen();
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteNotification'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('DELETE_NOTIFY', false);
            }
        },
    },
    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.notification_add)
        },
        addCamera() {
            this.$router.push('/user/add-notification').catch(() => {
            })
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },

        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
        initScreen() {
            this.$vs.loading();
            this.$crm.get('/announcement/find-all').then((response) => {
                this.organizationBranchList = response.data.map(item => {
                    item.fullName = (item.employeeDetailResponseDTOS.length > 0 && item.announcementType == 1) ? item.employeeDetailResponseDTOS[0].fullName: this.$t('notificationV.all')
                    return item            
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
